import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-541a0c96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "componentHeade" }
const _hoisted_2 = { class: "leftBox" }
const _hoisted_3 = { class: "userInfo" }
const _hoisted_4 = { class: "el-dropdown-link" }
const _hoisted_5 = {
  key: 0,
  class: "pwd-strength-meter"
}
const _hoisted_6 = { class: "pwd-strength-bars" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "password-tip" }, " 温馨提示：密码需要8-18位，且包含至少一个字母+至少一个数字，@$!%*#?&中至少一个特殊字符。 ", -1))
const _hoisted_8 = { class: "dialog-footer" }

import { toRef, ref, reactive, computed } from "vue";
import { ElMessage, ElMessageBox, FormInstance, FormRules } from "element-plus";
import { useRouter } from "vue-router";
import { isMatchPwd } from "@/utiles/utiles";
import { ArrowDown } from "@element-plus/icons-vue";

import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'componentHeade',
  props: ["isCollapse"],
  emits: ["setIsCollapse"],
  setup(__props, { emit }) {

const props = __props;

const { loginOut, updatePw } = require("./api");
const userInfo = JSON.parse(sessionStorage.getItem("userInfo") || "");
const userName = ref<string>(userInfo.name || "用户名");

const ruleFormRef = ref<FormInstance>();

const dialogVisible = ref(false);
const isCollapse = toRef(props, "isCollapse");
const Router = useRouter();
const store = useStore();
const newPasswordValidationMessage = computed(() => {
  if (!ruleForm.password) return "";
  const errors: string[] = [];
  if (ruleForm.password.length < 8 || ruleForm.password.length > 18) {
    errors.push("密码长度需要在8-18位之间");
  }
  if (!/[A-Za-z]/.test(ruleForm.password)) {
    errors.push("需要包含至少一个字母");
  }
  if (!/[0-9]/.test(ruleForm.password)) {
    errors.push("需要包含至少一个数字");
  }
  if (!/[@$!%*#?&]/.test(ruleForm.password)) {
    errors.push("需要包含至少一个特殊字符(@$!%*#?&)");
  }

  // 如果没有错误，就提示“新密码格式正确”，否则将所有错误拼成一个字符串
  return errors.length === 0 ? "新密码格式正确" : errors.join("\n");
});

// 密码强度等级(0=无, 1=弱, 2=中, 3=强)
const newPasswordStrengthLevel = computed(() => {
  const pwd = ruleForm.password;
  if (!pwd) return 0;

  let score = 0;
  if (pwd.length >= 8) score++;
  if (/[A-Za-z]/.test(pwd)) score++;
  if (/[0-9]/.test(pwd)) score++;
  if (/[@$!%*#?&]/.test(pwd)) score++;

  if (score <= 2) return 1;
  if (score === 3) return 2;
  return 3;
});
const handleCommand = (command: string | number | object) => {
  if (command === "exitTheSystem") {
    exitTheSystem();
  } else if (command === "changePassword") {
    changePassword();
  }
  console.log(`click on item ${command}`);
};
const validatePass = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("请输入密码"));
  } else {
    if (ruleForm.oldPassword !== "") {
      let reg = new RegExp(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,18}$/);
      if (!reg.test(ruleForm.oldPassword)) {
        callback("请输入8-18位数字加字母");
      } else {
        callback();
      }
    }
  }
};
const validatePass1 = (rule: any, value: any, callback: any) => {
  console.log("value", value);
  console.log("ruleForm", ruleForm);
  if (value === "") {
    callback(new Error("请输入密码"));
  } else if (value === ruleForm.oldPassword) {
    callback(new Error("新密码不能与旧密码一致"));
  } else {
    if (!isMatchPwd(ruleForm.password)) {
      callback("请按照密码规则修改");
    } else {
      callback();
    }
  }
};
const validatePass2 = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("请输入密码"));
  } else if (value !== ruleForm.password) {
    callback(new Error("新密码两次输入的不一致"));
  } else {
    if (!isMatchPwd(ruleForm.password)) {
      callback("请按照密码规则修改");
    } else {
      callback();
    }
  }
};
const ruleForm = reactive({
  password: "",
  oldPassword: "",
  newpassword: "",
});
const rules = reactive<FormRules>({
  oldPassword: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
  password: [
    { required: true, message: "请输入新密码", trigger: "blur" },
    { validator: validatePass1, trigger: "blur" },
  ],
  newpassword: [
    { required: true, message: "请确认新密码", trigger: "blur" },
    { validator: validatePass2, trigger: "blur" },
  ],
});
const handleClose = (formEl: any, type: Boolean) => {
  if (!formEl) return;
  formEl.resetFields();
  if (type) {
    dialogVisible.value = false;
  }
};
const changePassword = () => {
  dialogVisible.value = true;
};
const updatePassW = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid: any, fields: any) => {
    if (valid) {
      updatePw({
        password: ruleForm.password,
        oldPassword: ruleForm.oldPassword,
      }).then(() => {
        ElMessageBox.alert(`你的新密码是:${ruleForm.password}`, "提示", {
          confirmButtonText: "退出重新登录",
          showClose: false,
          showCancelButton: false,
          closeOnClickModal: false,
        }).then(() => {
          loginOut({}).then(() => {
            ElMessage({
              type: "success",
              message: "退出成功",
            });
            localStorage.clear();
            sessionStorage.clear();
            Router.push("/Login");
            store.dispatch("tabs/resetTabs");
          });
        });
      });
    }
  });
};
const updatePwFn = (action: any, instance: any, done: () => void) => {
  console.log(action, instance.inputValue);
  if (action == "cancel") {
    done();
  } else {
    updatePw({ password: instance.inputValue }).then(() => {
      ElMessage({
        type: "success",
        message: `你的新密码是:${value}`,
      });
      ElMessageBox.alert(`你的新密码是:${value}`, "提示", {
        confirmButtonText: "退出重新登录",
        showClose: false,
        showCancelButton: false,
        closeOnClickModal: false,
      }).then(() => {
        loginOut({}).then(() => {
          ElMessage({
            type: "success",
            message: "退出成功",
          });
          localStorage.clear();
          sessionStorage.clear();
          Router.push("/Login");
          store.dispatch("tabs/resetTabs");
        });
      });
      done();
    });
  }
};
const exitTheSystem = () => {
  ElMessageBox.confirm("是否退出登录?", "提 示", {
    confirmButtonText: "确 定",
    cancelButtonText: "取 消",
    type: "warning",
  }).then(() => {
    loginOut({}).then(() => {
      ElMessage({
        type: "success",
        message: "退出成功",
      });

      // 清理Vuex状态
      store.commit("SET_MENU", { menu: [] });
      store.commit("SET_MENUTREE", { menu: [] });

      // 删除本地缓存（关键！）
      localStorage.removeItem("menu"); // 对应 setCache('menu', ...)
      localStorage.removeItem("menuTree"); // 对应 setCache('menuTree', ...)
      // localStorage.clear();
      // const url = sessionStorage.getItem('code') ? `/Login?code=${sessionStorage.getItem('code')}` : '/Login'

      store.dispatch("tabs/resetTabs");

      const code =
        JSON.parse(sessionStorage.getItem("userInfo"))?.compCode ||
        sessionStorage.getItem("code");
      const url = `#/Login?code=${code}`;
      // window.location.href = url;
      // Router.go(0);
      localStorage.removeItem(
        `token:${JSON.parse(sessionStorage.getItem("userInfo"))?.id}`
      );
      sessionStorage.clear();

      window.location.href = url;
      Router.go(0);
    });
  });
};
const setIsCollapse = () => {
  emit("setIsCollapse", !isCollapse.value);
};

return (_ctx: any,_cache: any) => {
  const _component_Expand = _resolveComponent("Expand")!
  const _component_Fold = _resolveComponent("Fold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_icon, {
        style: {"font-size":"30px"},
        onClick: setIsCollapse
      }, {
        default: _withCtx(() => [
          (_unref(isCollapse))
            ? (_openBlock(), _createBlock(_component_Expand, { key: 0 }))
            : (_openBlock(), _createBlock(_component_Fold, { key: 1 }))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_image, {
        class: "image",
        src: require('../../../assets/image/head1.png'),
        fit: "cover"
      }, null, 8, ["src"]),
      _createVNode(_component_el_dropdown, {
        onCommand: handleCommand,
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, { command: "changePassword" }, {
                default: _withCtx(() => [
                  _createTextVNode("修改密码")
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, { command: "exitTheSystem" }, {
                default: _withCtx(() => [
                  _createTextVNode("退出系统")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_4, [
            _createTextVNode(_toDisplayString(userName.value) + " ", 1),
            _createVNode(_component_el_icon, { class: "el-icon--right" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowDown))
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogVisible).value = $event)),
      title: "修改密码",
      width: "30%",
      onClose: _cache[6] || (_cache[6] = ($event: any) => (handleClose(ruleFormRef.value, true)))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (updatePassW(ruleFormRef.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 确定 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: ruleForm,
          "status-icon": "",
          rules: rules,
          "label-width": "120px",
          class: "demo-ruleForm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "旧密码",
              prop: "oldPassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: ruleForm.oldPassword,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.oldPassword) = $event)),
                  "show-password": "",
                  maxlength: "18",
                  type: "password",
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "新密码",
              prop: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: ruleForm.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.password) = $event)),
                  "show-password": "",
                  maxlength: "18",
                  type: "password",
                  autocomplete: "off"
                }, null, 8, ["modelValue"]),
                (ruleForm.password)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["pwd-bar", { 'pwd-weak': _unref(newPasswordStrengthLevel) >= 1 }])
                        }, null, 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["pwd-bar", { 'pwd-medium': _unref(newPasswordStrengthLevel) >= 2 }])
                        }, null, 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["pwd-bar", { 'pwd-strong': _unref(newPasswordStrengthLevel) >= 3 }])
                        }, null, 2)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "确认密码",
              prop: "newpassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: ruleForm.newpassword,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.newpassword) = $event)),
                  "show-password": "",
                  type: "password",
                  maxlength: "18",
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _hoisted_7
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})